/* Grafilabel staffelprijzen (8 okt 2026) */
(function () {
  if (window.__glStaffelInit) return;
  window.__glStaffelInit = true;

  function eur(cents) {
    return '€ ' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function setup(root) {
    var section = root.getAttribute('data-section');
    var base = parseInt(root.getAttribute('data-base'), 10) || 0;
    var min = parseInt(root.getAttribute('data-min'), 10) || 1;
    var step = parseInt(root.getAttribute('data-step'), 10) || 1;
    var unit = root.getAttribute('data-unit');
    var units = root.getAttribute('data-units');
    var pack = root.getAttribute('data-pack');
    var packs = root.getAttribute('data-packs');
    var perPack = parseInt(root.getAttribute('data-per-pack'), 10) || 0;
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
    tiers.sort(function (a, b) { return a[0] - b[0]; });

    var input = document.getElementById('Quantity-' + section);
    var rows = root.querySelectorAll('[data-gl-st-row]');
    var nudge = root.querySelector('[data-gl-st-nudge]');
    var nudgeText = root.querySelector('[data-gl-st-nudge-text]');
    var nextBtn = root.querySelector('[data-gl-st-next]');
    var top = root.querySelector('[data-gl-st-top]');
    var toggle = root.querySelector('[data-gl-st-toggle]');
    var table = root.querySelector('.gl-st__table');
    var total = document.querySelector('[data-gl-st-total="' + section + '"]');

    if (toggle && table) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        table.classList.toggle('is-open', open);
        var label = toggle.querySelector('[data-gl-st-toggle-label]');
        if (label) label.textContent = open ? 'Verberg staffelprijzen' : 'Bekijk alle staffelprijzen';
      });
    }

    if (!input) return;

    // Minimum en veelvoud op het aantalveld zetten
    if (min > 1 || step > 1) {
      input.min = min;
      input.step = step;
      input.setAttribute('data-min', min);
      var cur = parseInt(input.value, 10) || 0;
      if (cur < min) input.value = min;
      else if (step > 1 && cur % step !== 0) input.value = Math.ceil(cur / step) * step;
    }

    function priceFor(q) {
      var p = base;
      tiers.forEach(function (t) { if (q >= t[0]) p = t[1]; });
      return p;
    }

    function amount(n) {
      if (perPack > 1 && pack && n % perPack === 0) {
        var k = n / perPack;
        return k + ' ' + (k === 1 ? pack : packs);
      }
      return n + ' ' + (n === 1 ? unit : units);
    }

    function update() {
      var q = parseInt(input.value, 10) || min;
      var activeFrom = null;
      rows.forEach(function (r) {
        var from = parseInt(r.getAttribute('data-from'), 10);
        if (q >= from) activeFrom = from;
      });
      rows.forEach(function (r) {
        r.classList.toggle('is-active', parseInt(r.getAttribute('data-from'), 10) === activeFrom);
      });

      var next = tiers.filter(function (t) { return t[0] > q; })[0];
      if (nudge && top) {
        if (tiers.length && next) {
          var need = next[0] - q;
          var target = Math.ceil(next[0] / step) * step;
          nudgeText.innerHTML = 'Nog <strong>' + (need === 1 ? '1 ' + unit : need + ' ' + units) + '</strong> tot <strong>' + eur(next[1]) + '</strong> per ' + unit;
          nextBtn.textContent = '+ ' + amount(target - q) + ' toevoegen';
          nextBtn.onclick = function () {
            input.value = target;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          };
          nudge.hidden = false;
          top.hidden = true;
        } else if (tiers.length) {
          nudge.hidden = true;
          top.hidden = false;
        }
      }

      if (total && tiers.length) {
        var p = priceFor(q);
        var html = '<span>Totaal <strong>' + eur(q * p) + '</strong> excl. BTW</span>';
        if (p < base) html += '<span class="gl-st-total__save">U bespaart ' + eur(q * (base - p)) + '</span>';
        total.innerHTML = html;
        total.hidden = false;
      }
    }

    input.addEventListener('change', update);
    input.addEventListener('input', update);
    var qi = input.closest('quantity-input');
    if (qi) qi.addEventListener('click', function () { setTimeout(update, 0); });
    update();
  }

  function init() {
    document.querySelectorAll('[data-gl-staffel]').forEach(function (el) {
      if (el.__glDone) return;
      el.__glDone = true;
      setup(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
